import _ from 'underscore';
import ko from 'knockout';
import { scopeOptions, emailOptions } from './options';

export class RuleAuthoringViewModel {
  constructor({
    selectedRule,
    i18n,
    isActionText,
    currentUserId,
  }) {
    this.i18n = i18n;
    this.maxRuleNameLength = 255;
    this.inPreviewMode = ko.observable(false);
    this.emailOptions = _.map(emailOptions, (key, value) => ({
      Value: key,
      Text: i18n.getString(`NotificationType_${value}`),
    }));
    this.selectedRule = selectedRule;
    this.entity = this.selectedRule.entity;
    this.menuAction = this.selectedRule.action;
    this.isEditRule = this.selectedRule.id != null;
    this.isEditRuleWithDifferentUser = this.selectedRule.id != null &&
      this.selectedRule.modifiedBy.id !== currentUserId;
    this.editRuleId = this.selectedRule.id != null ? this.selectedRule.id : null;
    this.editRuleWarningMessage = this.selectedRule.id != null ?
      i18n.getString('RulesManagement_EditRuleWarningMessage')
        .replace(/\{0\}/g, this.selectedRule.modifiedBy.name) :
      '';
    const actionName = i18n.getString(`RuleAction_${this.entity}_${this.menuAction}`);
    const ruleName = this.selectedRule.id == null ? actionName : this.selectedRule.name;
    let titleName = this.selectedRule.id == null ?
      i18n.getString('RuleAuthoring_Title') :
      i18n.getString('RuleAuthoring_Title_EditRule');
    titleName += ruleName;
    this.titleName = ko.observable(titleName);
    this.ruleName = ko.observable(ruleName);
    this.isActionText = ko.observable(isActionText);
    this.actionText = ko.observable(actionName);
    this.titleDescription = ko.observable((i18n.getString('RuleAuthoring_Description') || '').replace('LearnHowAriaLabel', i18n.getString('RuleAuthoring_Description_LearnHowAriaLabel')).replace('ExamplesAriaLabel', i18n.getString('RuleAuthoring_Description_ExamplesAriaLabel')));
    this.showCampaigns = this.entity === 'Campaign';
    this.showAdGroups = this.entity === 'AdGroup';
    this.showCampaignAdGroupSelector = ko.observable(false);
    this.isSelectorOpen = ko.observable(false);
    this.setupScopeOption();

    // Common setting shared accross all entities.
    this.selectedScopeInfo = this.selectedRule.scopeInfo;
    this.selectedEmailOption = ko.observable(this.selectedRule.emailOption);
    this.isEmailOption = ko.computed(() => this.menuAction !== 'SendEmail', this, {
      pure: true,
    });

    // validate related properties.
    this.scopeErrorMessage = ko.observable('');
    this.ruleNameErrorMessage = ko.observable('');
    this.selectedScopeOption.subscribe(() => {
      this.scopeErrorMessage('');
    }, this);
    this.ruleName.subscribe(() => {
      this.ruleNameErrorMessage('');
    }, this);

    this.ruleNameErrorRole = ko.computed(() => (this.ruleNameErrorMessage() === '' ? 'none' : 'alert'), this);
    this.scopeErrorRole = ko.computed(() => (this.scopeErrorMessage() === '' ? 'none' : 'alert'), this);

    this.validate = () => {
      this.scopeErrorMessage('');
      this.ruleNameErrorMessage('');
      let isResultValid = true;
      const scopeInfo = this.selectedScopeInfo;
      if (this.selectedScopeOption() === scopeOptions.Selected &&
                    (_.isNull(scopeInfo) ||
                     _.isNull(scopeInfo.selectedRowIds) ||
                     _.isNull(scopeInfo.selectedRowIds.length) ||
                     scopeInfo.selectedRowIds.length <= 0)) {
        this.scopeErrorMessage(i18n.getString('Validate_RowSelectionRequire'));
        isResultValid = false;
      }

      if (this.ruleName() == null || this.ruleName().length === 0 ||
        this.ruleName().length > this.maxRuleNameLength) {
        this.ruleNameErrorMessage(i18n.getString('Validate_InvalidRuleName'));
        isResultValid = false;
      }
      return isResultValid;
    };
  }

  setupScopeOption() {
    const { scopeInfo } = this.selectedRule;
    let level = 'Account';

    if (_.isNumber(this.selectedRule.scopeInfo.adGroupId)) {
      level = 'AdGroup';
    } else if (_.isNumber(this.selectedRule.scopeInfo.campaignId)) {
      level = 'Campaign';
    }

    const options = [];

    _.each(scopeOptions, (key, value) => {
      if (this.menuAction === 'Enable' && key === scopeOptions.AllEnabled) {
        return;
      }

      if (!(this.isEditRule && (this.showCampaigns || this.showAdGroups))
        && scopeInfo.allPages && key === scopeOptions.Selected) {
        return;
      }

      options.push({
        Value: key,
        Text: this.i18n.getString(`RuleScope_${this.entity}_${value}_${level}`),
      });
    });

    this.defaultSelectedScopeOptionText = options[0].Text;
    this.selectedScopeOption = ko.observable(this.selectedRule.scopeOption);

    options[0].Text = this.defaultSelectedScopeOptionText;
    const len = scopeInfo.selectedRowCount;
    if (scopeInfo.allPages === false && !_.isNull(len) && len > 0) {
      this.selectedScopeOption = ko.observable(scopeOptions.Selected);
    }

    this.scopeOptions = ko.observable(options);
  }

  updateSelectedEntityCount(info) {
    this.selectedScopeInfo = info;
    let selectedScopeOption = this.selectedScopeOption();

    const { allPages, selectedRowCount } = info || {};
    const updatedScopeOptions = _.clone(this.scopeOptions());

    // currently for selected, we only show 'selected' without numbers
    updatedScopeOptions[0].Text = this.defaultSelectedScopeOptionText;
    if (allPages) {
      selectedScopeOption = scopeOptions.AllButRemoved;
    } else if (selectedRowCount > 0) {
      selectedScopeOption = scopeOptions.Selected;
    }

    // trigger the ko binding update
    this.scopeOptions([]);
    this.scopeOptions(updatedScopeOptions);
    if (selectedScopeOption !== this.selectedScopeOption()) {
      this.selectedScopeOption(selectedScopeOption);
    }
  }
}
